
export const FETCH_GEOLOCATION_RISK_ORG_REQUEST = 'FETCH_GEOLOCATION_RISK_ORG_REQUEST';
export const FETCH_GEOLOCATION_RISK_ORG_SUCCESS = 'FETCH_GEOLOCATION_RISK_ORG_SUCCESS';
export const FETCH_GEOLOCATION_RISK_ORG_ERROR = 'FETCH_GEOLOCATION_RISK_ORG_ERROR';
